import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/build/layouts/default.vue").then(m => m.default || m))
}